const liveStatus = {
  IN_PROGRESS: 'live in progress',
  FINISHED: 'live finished',
  COMING: 'live soon',
  WAITING_VOD: 'waiting vod',
};

export default liveStatus;
